// Справочник регионов России с иерархией: Федеральный округ → Субъект → Район → Населенный пункт
// Данные загружаются из russiaRegions-full.json

export interface Settlement {
  name: string;
  type: 'city' | 'town' | 'village' | 'settlement';
  latitude: number;
  longitude: number;
  timezone: string;
}

export interface District {
  name: string;
  settlements: Settlement[];
}

export interface Subject {
  name: string;
  type: 'oblast' | 'krai' | 'republic' | 'city' | 'autonomous_oblast' | 'autonomous_okrug';
  districts: District[];
}

export interface FederalDistrict {
  name: string;
  subjects: Subject[];
}

// Импортируем данные из JSON
import regionsData from './russiaRegions-full.json';

export const RUSSIA_REGIONS: FederalDistrict[] = regionsData as FederalDistrict[];

// Вспомогательные функции для получения данных
export function getSubjects(districtName: string): Subject[] {
  const district = RUSSIA_REGIONS.find(d => d.name === districtName);
  return district?.subjects || [];
}

export function getDistricts(districtName: string, subjectName: string): District[] {
  const subjects = getSubjects(districtName);
  const subject = subjects.find(s => s.name === subjectName);
  return subject?.districts || [];
}

export function getSettlements(districtName: string, subjectName: string, districtDistrictName: string): Settlement[] {
  const districts = getDistricts(districtName, subjectName);
  const district = districts.find(d => d.name === districtDistrictName);
  return district?.settlements || [];
}

export function getSubjectTypeName(type: Subject['type']): string {
  const names: Record<Subject['type'], string> = {
    oblast: 'область',
    krai: 'край',
    republic: 'республика',
    city: 'город федерального значения',
    autonomous_oblast: 'автономная область',
    autonomous_okrug: 'автономный округ',
  };
  return names[type] || type;
}

// Поиск населенного пункта по имени
export function findSettlements(query: string): Array<{ 
  federalDistrict: string; 
  subject: string; 
  district: string; 
  settlement: Settlement 
}> {
  const lowerQuery = query.toLowerCase();
  const results: Array<{ 
    federalDistrict: string; 
    subject: string; 
    district: string; 
    settlement: Settlement 
  }> = [];

  for (const fd of RUSSIA_REGIONS) {
    for (const subject of fd.subjects) {
      for (const district of subject.districts) {
        for (const settlement of district.settlements) {
          if (settlement.name.toLowerCase().includes(lowerQuery)) {
            results.push({
              federalDistrict: fd.name,
              subject: subject.name,
              district: district.name,
              settlement
            });
          }
        }
      }
    }
  }

  return results.slice(0, 20); // Ограничиваем до 20 результатов
}
